/*
 * PDP Stats Grid — sound toggle binding (Phase 3b)
 *
 * Wires the mute/unmute button next to the autoplaying vertical video.
 * Each .pdp-stats root is bound once (idempotent via data-bound).
 * Re-binds in the theme editor when the section reloads.
 */
(function () {
  'use strict';

  function init(root) {
    var btn = root.querySelector('[data-pdp-stats-sound]');
    var video = root.querySelector('.pdp-stats__video video');
    if (!btn || !video || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    var frame = root.querySelector('.pdp-stats__video');

    // Touch has no hover, so tapping the video reveals the control for a few
    // seconds and then fades it out — long enough to mute and keep reading.
    var REVEAL_MS = 3000;
    var revealTimer;
    function revealControls() {
      clearTimeout(revealTimer);
      root.classList.add('pdp-stats--controls-visible');
      revealTimer = setTimeout(function () {
        root.classList.remove('pdp-stats--controls-visible');
      }, REVEAL_MS);
    }

    if (frame) {
      // Clearing the dismissed flag on mouseleave is what lets the control come
      // back when the pointer re-enters the video, instead of staying hidden.
      frame.addEventListener('mouseleave', function () {
        root.classList.remove('pdp-stats--toggle-dismissed');
      });
      // pointerType checked at event time rather than matchMedia at load, so
      // hybrid laptops behave correctly whichever input is actually used.
      frame.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') revealControls();
      });
    }

    btn.addEventListener('click', function () {
      var unmuting = video.muted;
      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', String(unmuting));
      btn.setAttribute('aria-label', unmuting ? 'Mute video' : 'Unmute video');
      root.classList.toggle('pdp-stats--unmuted', unmuting);
      // Hide the control straight after unmuting even though the pointer has not
      // moved; muting again should leave it visible, so only set it on unmute.
      root.classList.toggle('pdp-stats--toggle-dismissed', unmuting);
      if (unmuting) {
        // Every unmute restarts from the top: the video loops on autoplay while
        // muted, so whenever sound is turned on the viewer is dropped mid-clip
        // and would miss whatever already played. Previously only the first
        // unmute rewound, which made a second unmute resume mid-loop.
        try { video.currentTime = 0; } catch (e) {}
        var play = video.play();
        if (play && typeof play.catch === 'function') play.catch(function () {});
      }
    });
  }

  function run() {
    var nodes = document.querySelectorAll('.pdp-stats');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
